import { useAuthStore } from '../../../store/authStore'
import { usePhoneRegistrationStore } from '../../../store/phoneRegistrationStore'
import type { SessionTokens } from '../types/phoneAuth'

export const saveSession = (tokens: SessionTokens) => {
  const { setToken, setRefreshToken } = useAuthStore.getState()

  setToken(tokens.access_token, tokens.token_type)

  if (tokens.refresh_token) {
    setRefreshToken(tokens.refresh_token)
  }

  usePhoneRegistrationStore.getState().clearRegistration()
}
